(function () {
    'use strict';

    // Turnstile for a plain (full-page post) form. Mark the form data-turnstile-form="<action>"; inside it put the
    // widget slot (.turnstile-slot), a hidden input the renderer writes the token to ([data-turnstile-input]), and a
    // hidden banner ([data-turnstile-banner]) for when the check isn't done. Rendering is the shared
    // window.SmaoinTurnstile's. A submit with no token is blocked with a reason, never sent to fail as a generic
    // "Security check failed" — the same guard the pre-register page has inline.
    const PENDING  = 'Just finishing the security check — give it a few seconds and press the button again.';
    // Cloudflare wants a tick (turnstile-tick.js) - waiting a few seconds would never be enough.
    const TICK     = 'One more step: tick the box, then press the button again.';
    const FALLBACK = "Security check couldn't load — check for an ad-blocker or privacy extension blocking Cloudflare, then refresh the page and try again.";

    document.querySelectorAll('form[data-turnstile-form]').forEach(function (form) {
        const container = form.querySelector('.turnstile-slot');
        const input     = form.querySelector('[data-turnstile-input]');
        const banner    = form.querySelector('[data-turnstile-banner]');
        if (!container || !input || !input.id) return;

        let tokenReady = false;
        let hadFailure = false;

        window.SmaoinTurnstile.render(container, input.id, {
            action:  form.getAttribute('data-turnstile-form'),
            onToken: function () { tokenReady = true; hadFailure = false; if (banner) banner.hidden = true; },
            onExpire: function () { tokenReady = false; },
            onFail:  function () { tokenReady = false; hadFailure = true; }
        });

        form.addEventListener('submit', function (e) {
            if (tokenReady && input.value) return;
            e.preventDefault();
            if (banner) {
                banner.textContent = window.SyvTurnstileTick.showing(container) ? TICK : hadFailure ? FALLBACK : PENDING;
                banner.hidden = false;
            }
        });
    });
}());
